<template>
  <div class="qqField">
    <div class="label"><span class="required">*</span>{{ label }}</div>
    <div class="value">
      <input
        v-model="qqField"
        type="number"
        placeholder="输入您的qq号"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "qqField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      qqField: "",
    };
  },
  async mounted() {},
  methods: {
    handleInput(val) {
      this.qqField = val.target.value;
      this.$emit("input", val.target.value);
    },
  },
  watch: {
    value(newVal) {
      this.qqField = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.qqField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 80px;
  .required {
    color: #ff0000;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 33px;
  border-radius: 17px;
  background: #F8F8F8;
  padding-left: 16px;
  font-size: 14px;
  input {
    border: none;
    outline: none;
    background: transparent;
    &::placeholder {
      color: rgba(51,51,51,0.4);
    }
  }
}
</style>
